<template>
  <div>
    <!-- 产品详情 -->
    <!-- 产品详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="产品详情"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="84.4%"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="pxDialog">
        <el-form
          :label-position="labelPosition"
          :model="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
        >
          <el-form-item class="inputA" label="产品名称:">
            <span class="posiA">*</span>
            <el-input v-model="ruleForm.ProductName" disabled placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item class="inputA" label="产品简述:">
            <span class="posiA">*</span>
            <el-input v-model="ruleForm.description" disabled placeholder="请输入产品简述"></el-input>
          </el-form-item>
          <el-form-item class="inputA" label="年龄限制范围:" >
            <div class="form_ages">
              <el-input v-model="ruleForm.age_range_start" disabled placeholder="请输入最小年龄">
                <template slot="append">
                  岁
                </template>
              </el-input>
              <span>-</span>
              <el-input v-model="ruleForm.age_range_end" disabled placeholder="请输入最大年龄">
                <template slot="append">
                  岁
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item class="inputA" label="地域限制:">
              <div class="form_ages">
                <el-input v-model="ruleForm.province_name"  placeholder="请输入省">
                </el-input>
                <span>-</span>
                <el-input v-model="ruleForm.city_name"   placeholder="请输入市">
                </el-input>
              </div>
            </el-form-item>
          <div class="disA">
            <el-form-item label="产品分类:">
              <span class="posiA">*</span>
              <el-input v-model="ruleForm.typename" disabled placeholder="产品分类"></el-input>
            </el-form-item>

            <el-form-item label="最少起订时间:" v-if="ruleForm.ProductType=='3'">
              <span class="posiB">*</span>
              <div class="disA">
                <el-input v-model="ruleForm.Hour" disabled>
                  <!-- <template>
                  <slot slot="suffix">分钟</slot>
                  </template>-->
                </el-input>
                <span>分钟</span>
              </div>
            </el-form-item>
          </div>
          <div v-if="ruleForm.ProductType==20&&ruleForm.type==0">
              <div class="son_border" v-for="(item,index) in son" :key="index" >
                <el-form-item class="inputA" label="子产品名称:" >
                  <el-input v-model="item.productname_son" disabled placeholder="请输入子产品名称"></el-input>
                  <!-- <el-select v-model="item.product_son_id" disabled  placeholder="请选择产品名称">
                    <el-option
                      v-for="item in tableDataName"
                      :key="item.id"
                      :label="item.product_son_name"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="子产品数量:" >
                  <el-input v-model="item.son_number" disabled onkeyup="this.value=this.value.replace(/\D|^0/g,'')"  placeholder="请输入子产品数量"></el-input>
                </el-form-item>
                <el-form-item label="子产品价格:" >
                  <el-input v-model="item.price_son"  disabled @input="limitNum(item.price_son,index)"  placeholder="请输入子产品价格"></el-input>
                </el-form-item>
                <!-- <el-form-item label="子产品分类:" >
                  <el-select v-model="item.type_son" disabled clearable placeholder="请选择产品分类">
                      <el-option
                        v-for="item in sonOption"
                        :key="item.id"
                        :label="item.typename"
                        :value="item.id"
                      ></el-option>
                  </el-select>
                </el-form-item> -->
              </div>
            </div>
          <div class="disAA" v-if="ruleForm.ProductType=='3'">
            <el-form-item label="场地类型:">
              <span class="posiA">*</span>
              <el-select v-model="ruleForm.place" placeholder="请选择活动类型" disabled>
                <el-option
                    v-for="item in placeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场地编号:">
              <span class="posiA">*</span>
              <el-input v-model="ruleForm.serialNumber" disabled placeholder="请输入产品简述"></el-input>
            </el-form-item>
          </div>
          <div class="disB" v-if="ruleForm.type!=0">
            <!-- <el-form-item label="完善身份证信息:">
              <el-radio-group v-model="ruleForm.IDCard" disabled>
                <el-radio label="0">不需要</el-radio>
                <el-radio label="1">需要</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item label="身份证刷门禁进入:">
              <el-radio-group v-model="ruleForm.card_access" disabled>
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">不启用</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="产品模式:">
            <el-radio-group v-model="ruleForm.type" disabled>
              <el-radio :label="0">期票模式</el-radio>
              <el-radio :label="1">日历模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="disE">
            <el-form-item label="销售有效期:">
              <el-radio-group v-model="ruleForm.ValidStatus" disabled>
                <el-radio label="2">设置</el-radio>
              </el-radio-group>
              <el-date-picker
                disabled
                style="margin-left:10px"
                v-model="sell"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </div>
          <!-- <div class="xfrq">
            <el-form-item label="场馆时间:">
              <span class="posiA">*</span>
              <el-date-picker
                v-model="Venue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </div> -->

          <!-- 期票模式 -->
          <el-form-item label="消费日期:" >
            <el-radio-group v-model="ruleForm.ConsumeState" v-if="ruleForm.type=='0'" disabled>
              <el-radio :label="1">景区设置</el-radio>
              <el-radio :label="2">生效时间设置</el-radio>
            </el-radio-group>
            <div class="disW">
                <span class="disR"  v-if="ruleForm.ConsumeState==2&&ruleForm.type==0">
                  <span>购票</span>
                  <el-input v-model="ruleForm.Hour" disabled></el-input>
                  <span>小时后</span>
                </span>
            </div>
            <div class="disW">
              <!-- <span class="posiA">*</span> -->
              <div  v-if="ruleForm.ConsumeState=='1'">
                <el-date-picker
                  disabled
                  style="margin-left:10px"
                  v-model="consume"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </div>
              <div v-if="ruleForm.ConsumeState=='2'" class="conendTime">
                <el-date-picker
                v-model="endtimes"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              </div>
          </div>
          </el-form-item>
          
          <el-form-item label="可用星期:" v-if="ruleForm.type!='1'">
            <span class="posiA">*</span>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" disabled>
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="可用时间:" >
            <el-time-picker
              is-range
              disabled
              v-model="valueTime"
              format='HH:mm'    
              value-format="HH:mm"  
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              >
            </el-time-picker>
            <div style="color: #FF4D4F;">(24小时制)</div>
          </el-form-item>
          <div class="xDItem" v-if="ruleForm.type=='1'">
            <el-form-item label="下单设置:">
              <span>用户需在指定日期</span>
              <el-input v-model="ruleForm.preday" disabled></el-input>
              <span>天</span>
              <el-time-picker
                disabled
                v-model="ruleForm.pretime"
                placeholder="任意时间点"
                format='HH:mm'    
    value-format="HH:mm"  
              ></el-time-picker>
              <span>前下单</span>
            </el-form-item>
          </div>
          <div class="disF">
            <el-form-item label="门市价:">
              <el-input disabled v-model="ruleForm.Price"></el-input>
            </el-form-item>
            <span>元</span>
          </div>
          <div class="disFF">
            <el-form-item label="销售价:">
              <el-input v-model="ruleForm.SellPrice" disabled></el-input>
            </el-form-item>
          </div>
          <div class="dataZd" v-if="ruleForm.type=='1'">
            <div class="btnHer">
              <div class="her" @click="getPreMonth" >
                上一个月
              </div>
              <div class="her" @click="getGoMonth" >
                下一个月
              </div>
            </div>
            <el-calendar  v-model="value">
              <div slot="dateCell" slot-scope="{date, data}" >
                <p
                  :class="data.isSelected ? 'is-selected' : ''" 
                >{{ data.day }} {{ data.isSelected ? '✔️' : ''}}</p>
                <div class="contentForm" v-for="(items,index) in dateList" :key="index"  v-show="items.date==data.day">
                  <div v-if="items.status=='1'">
                      <div>
                    <div>门市价:</div>
                    <div>¥{{items.price}}</div>
                  </div>
                  <div>
                    <div>售卖价:</div>
                    <div>¥{{items.sellprice}}</div>
                  </div>
                  <div >
                    <div>代理价:</div>
                    <div>¥{{ items.agentprice }}</div>
                  </div>
                  <div>
                    <div>库存:</div>
                    <div>{{items.daynumber}}</div>
                  </div>
                    </div>
                    <div v-if="items.status=='2'" class="ting">停售</div>
                </div>
              </div>
            </el-calendar>
          </div>
          <div class="disG">
            <el-form-item label="代理价:" v-if="ruleForm.type==0">
              <el-input v-model="ruleForm.AgentPrice" disabled></el-input>
              <span>元</span>
            </el-form-item>
            <el-form-item label="押金金额:">
              <el-input v-model="ruleForm.Deposit" disabled></el-input>
              <span>元</span>
            </el-form-item>
          </div>
          <div class="disH">
            <el-form-item label="日库存:">
              <el-input v-model="ruleForm.NumBerflag" disabled></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
            <el-form-item label="退票:">
              <el-radio-group v-model="ruleForm.ReturnFlag" disabled>
                <el-radio :label="1">禁止退票</el-radio>
                <el-radio :label="0">允许退票</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="disK">
            <el-form-item label="每日数量限制:">
              <el-input v-model="ruleForm.NumBerflag" disabled></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
            <el-form-item label="总量限制:">
              <el-input v-model="ruleForm.Number" disabled></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
          </div>
          <div class="disK">
            <el-form-item label="每日预定数量限制:">
              <el-input v-model="ruleForm.DayNum" disabled></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
            <el-form-item label="预定总量限制:">
              <el-input v-model="ruleForm.AllNum" disabled></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
          </div>
          <el-form-item label="产品描述:">
            <div class="proA">
              <quill-editor 
                v-model="ruleForm.Memo" 
                disabled
                ref="myQuillEditor" 
              >
            </quill-editor>
            </div>
          </el-form-item>
          <div class="fpCss">
            <el-form-item label="发票开具说明:">
              <quill-editor 
                v-model="ruleForm.invoice_instructions" 
                disabled
                ref="myQuillEditor" 
              >
            </quill-editor>
            </el-form-item>
          </div>
          <div class="proFm">
            <el-form-item label="产品封面:">
              <el-upload action="#" list-type="picture-card" :auto-upload="false" disabled   :limit="5"
              :file-list="transDetImgList">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
            <span class="spanB">
              <span>注:</span>
              <span>请上传1M以下的图片(此图片用于平台餐品宣传,请认真对待),支持png,jpg,jpeg</span>
            </span>
          </div>
          <el-form-item label="产品主图:">
            <el-upload action="#" list-type="picture-card" :auto-upload="false" disabled>
              <i slot="default" class="el-icon-plus" v-if="ruleForm.WebPi==''"></i>
              <div v-else>
                <img class="el-upload-list__item-thumbnail" :src="ruleForm.WebPic" alt />
              </div>
            </el-upload>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
              <img width="100%" :src="ruleForm.WebPic" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="状态:">
            <el-radio-group v-model="ruleForm.UseFlag" disabled>
              <el-radio :label="0">上线</el-radio>
              <el-radio :label="1">下线</el-radio>
            </el-radio-group>
            <span class="spanA">
              <span>注:</span>
              <span>默认为允许销售,下线则不允许销售</span>
            </span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 产品详情弹框结束 -->
  </div>
</template>

<script>
import {getProductNewTypeList,getProductCld} from '@/request/distributor.js'
import { ScenicProductSonType , getProductSonList , getProductInfo } from '@/request/scenic.js'
import { Message } from 'element-ui';
const cityOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
export default {
  props:['productId'],
  data() {
    return {
      transDetImgList:[],
      form: {
        name: ""
      },
      imgYw: require("@/images/scenic/yw.png"),
      imgZm: require("@/images/scenic/zm.png"),
      imgYwk: require("@/images/scenic/ywk.png"),
      imgZmk: require("@/images/scenic/zmk.png"),
      labelPosition: "right",
      addProDialogVisible: false, // 添加产品弹框
      titleType: "", // 弹框标题名
      // 图片
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      endtimes:'',
      ruleForm: {
        province_name:'',
        city_name:'',
        age_range_start:'',
        age_range_end:'',
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        radio: "",
        checkedCities: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" }
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
      },
     
      radio: "",
      input: "",
      radioType: "", // 产品日历类别
      dataType: "", // 日历类别弹框
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      // 产品类型
      ProductList:[],
      //场地类型
      placeList:[
        {
          value:'1',
          label:'全场'
        },
        {
          value:'2',
          label:'半场'
        }
      ],
      // 消费有效期
      consume:[],
      sell:[], // 销售有效期
      // 可用时间
      valueTime:[],
      // 场馆时间
      Venue:'',
      dateList:[],
      value:new Date(),
      son:[
        {
          productname_son:'',
          son_number:'',
          price_son:'',
          product_son_id:''
        }
      ],
      sonOption:[],
      tableDataName:[]
    };
  },
  created(){
    this.getProduct()
    this.getProductType()
    let data = {
      token:window.sessionStorage.getItem('Token')
    }
    ScenicProductSonType(data).then(res=>{
      if(res.data.status=='ok'){
        this.sonOption = res.data.result
      }
    })
  },
  methods: {
    getTime(date){
      console.log(date)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h =date.getHours()
      h = h < 10 ? ('0' + h) : h
      let M =date.getMinutes()
      M = M < 10 ? ('0' + M) : M
      let s =date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + m + '-' + d 
      // + ' ' + h + ':' + M + ':' + s;
    },
    // 点击获取上个月
    getPreMonth() {
      this.dateList = []
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.allcalendar(t2)
      this.value = new Date(t2)
    },
    getGoMonth(){
      this.dateList = []
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.allcalendar(t2)
      this.value = new Date(t2)
    },
     // 第一天
     getStartTime1(e) {
        let date = new Date(e)
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份 
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return  (day<10?'0'+day:day)// 这里传入的是字符串
    },
    // 最后一天
    getEndTime1(e){
      let  date  = new Date(e)
      let year = date.getFullYear()  
      let month = date.getMonth() +1
    // 这里传入的是整数时间，返回的是下个月的第一天，因为月份是0-11
      let nextMonthFirthDay = new Date(year,month,1) // 下个月的第一天
      console.log(nextMonthFirthDay)
      let oneDay = 1000*60 * 60 * 24 // 一天的时间毫秒数
      let endDay = new Date(nextMonthFirthDay - oneDay) 
      let day = endDay.getDate() // 本月最后一天
      // 这里传入的是字符串格式的时间，返回的是传入字符串的时间
      return (day<10?'0'+day:day)
    },
    allcalendar(e){
      var date = new Date(e);
      let firstDay =  this.getStartTime1(e)
      let lastDay = this.getEndTime1(e)
      var year = date.getFullYear(); // 年
      var month =  date.getMonth()+1 >= 10 ? date.getMonth()+1 : '0' + (date.getMonth()+1)// 月
      var first = year + '-' + month + '-' + firstDay  
      var last = year + '-' + month + '-' + lastDay  
      let data = {
        token:window.sessionStorage.getItem('Token'),
        goods_id:this.productId,
        startTime:first,
        endTime:last
      }
      getProductCld(data).then(res=>{
        if(res.data.rcode==200){
          this.dateList =  res.data.result
          this.dateList.map(item=>{
            item.stock = item.daynumber
          })
        }else{
          Message.error('暂无更多数据')
        }
      })
    },
    // 产品类型
    getProductType(){
      getProductNewTypeList().then(res=>{
        if(res.data.status=='ok'){
          this.ProductList =res.data.result
        }
      })
    },
    // 详情
    getProduct(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ProductID:this.productId
      }
      getProductInfo(data).then(res=>{
        if(res.data.status=='ok'){
            this.ruleForm = res.data.result
            this.ruleForm.ProductType = res.data.result.ProductType
            this.ruleForm.age_range_start = res.data.result.age_range_start
            this.ruleForm.age_range_end = res.data.result.age_range_end
            this.ruleForm.province_name = res.data.result.province_name
            this.ruleForm.city_name = res.data.result.city_name
            this.ruleForm.place = res.data.result.place + ''
            this.ruleForm.IDCard = res.data.result.IDCard + ''
            this.ruleForm.ValidStatus = res.data.result.ValidStatus + ''
            this.consume = [res.data.result.ConsumeBeginDate,res.data.result.ConsumeEndDate]
            this.sell = [res.data.result.ValidBeginDate,res.data.result.ValidEndDate]
            this.endtimes = res.data.result.ConsumeEndDate
            this.valueTime = [res.data.result.usebegintime , res.data.result.useendtime]
            this.Venue = [res.data.result.openTime,res.data.result.closeTime]
            if(res.data.result.ProductType!=20){
              this.son = [
                {
                  productname_son:'',
                  son_number:'',
                  price_son:'',
                }   
              ]
            }else{
              let data = {
                token:window.sessionStorage.getItem('Token'),
              }
              getProductSonList(data).then(res=>{
                if(res.data.status=='ok'){
                  this.tableDataName = res.data.result
                }
              })
              this.son = res.data.result.product_son
            }
            if(res.data.result.weeks!=''&&res.data.result.weeks!=null){
              JSON.parse(res.data.result.weeks).map(item=>{
              switch (item) {
                    case '7':
                        this.checkedCities.push('星期日')
                        break;
                    case '6':
                        this.checkedCities.push('星期六')
                        break;
                    case '5':
                        this.checkedCities.push('星期五')
                        break;
                    case '4':
                        this.checkedCities.push('星期四')
                        break;
                    case '3':
                        this.checkedCities.push('星期三')
                        break;
                    case '2':
                        this.checkedCities.push('星期二')
                        break;
                    case '1':
                        this.checkedCities.push('星期一')
                        break;
                   default:
              }
            })
            }
            let img = []
          if(this.ruleForm.image1){
            img.push({
              url:this.ruleForm.image1
            })
          }
          if(this.ruleForm.image2){
            img.push({
              url:this.ruleForm.image2
            })
          }
          if(this.ruleForm.image3){
            img.push({
              url:this.ruleForm.image3
            })
          }
          if(this.ruleForm.image4){
            img.push({
              url:this.ruleForm.image4
            })
          }
          if(this.ruleForm.image5){
            img.push({
              url:this.ruleForm.image5
            })
          }
          this.transDetImgList = img;
            if(res.data.result.type=='1'){
              var forms = {}
            if(new Date(this.getStartTime()).getTime()>new Date(this.consume[0]).getTime()){
                if(new Date(this.getEndTime()).getTime()>new Date(this.consume[1]).getTime()){
                  var enD = this.consume[1] 
                }else{
                  var enD = this.getEndTime()
                }
                forms = {
                  token:window.sessionStorage.getItem('Token'),
                  goods_id:this.productId,
                  startTime:this.getStartTime(),
                  endTime:enD.slice(0,10)
                }
            }else{
              this.value = new Date(this.consume[0])
              if(new Date(this.getEndTime(this.consume[0]))>new Date(this.consume[1])){
                var enD = this.consume[1]
              }else{
                var enD = this.getEndTime(this.consume[0])
              }
              forms = {
                token:window.sessionStorage.getItem('Token'),
                goods_id:this.productId,
                startTime:this.consume[0].slice(0,10),
                endTime:enD.slice(0,10)
              }
            }
              // let forms = {
              //   token:window.sessionStorage.getItem('Token'),
              //   goods_id:this.productId,
              //   startTime:this.getStartTime(),
              //   endTime:this.getEndTime()
              // }
              getProductCld(forms).then(ren=>{
                if(res.data.rcode==200){
                  this.dateList = ren.data.result
                }else{
                  Message.error('暂无更多数据')
                }
              })
            }
        }
      })
    },
      // 第一天
      getStartTime(e) {
      var dateObj = new Date()
        var y = dateObj.getFullYear(); //获取年份
        var m = dateObj.getMonth() + 1; //获取月份
        var d = '01';
        m = m < 10 ? '0' + m : m; //月份补 0
        return [y,m,d].join("-")
    },
    // 最后一天
    getEndTime(e){
      if(e){
          var dateObj = new Date(e)
        }else{
          var dateObj = new Date()
        }
        var y = dateObj.getFullYear(); //获取年份
        var m = dateObj.getMonth() + 1; //获取月份
        var d = new Date(y, m, 0).getDate(); //获取当月最后一日
        m = m < 10 ? '0' + m : m; //月份补 0
        d = d < 10 ? '0' + d : d; //日数补 0
        return [y,m,d].join("-")
    },
    submitForm() {},
    resetForm() {},
   
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
   
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 产品详情
    proInfo(row) {
      this.addProDialogVisible = true;
    },
    // 添加产品X
    addProHandleClose() {
      this.addProDialogVisible = false;
      this.$emit('close')
    }
  }
};
</script>

<style lang='less' scoped>
/deep/ .el-form-item span{
  color: #333 !important;
}

/deep/ .el-dialog{
  min-width: 1050px;
}
.contentForm {
  width: 130px;
  text-align: center;
  > div {
    display: flex;
    flex-direction: column;
    >div{
      display: flex;
      align-items: center;
      text-align: center;
      width: 100%;
      justify-content: center;
    }
    > div:nth-child(1) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
    }
    > div:nth-child(2) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #000000;
    }
  }
}

/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
/deep/.is-selected {
  color: #1989fa;
}
/deep/.el-calendar-table td.is-selected {
  background-color: none;
}
/deep/thead {
  th {
    margin-right: 10px;
    text-align: center !important;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    background: #246deb;
    border-radius: 4px 4px 0px 0px;
  }
}
tbody {
  p {
    width: 130px;
    text-align: center;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
  }
}

/deep/.prev {
  width: 200px;
}
/deep/.el-calendar-table tr td:first-child {
  border: none;
}
/deep/.el-calendar-table td {
  border: none;
}
/deep/.el-calendar-day {
  box-sizing: border-box;
  padding: 10px 0;
  height: 170px;
  width: 130px;
  background: #eaf1fd;
  border-top: 3px solid #87aff4;
}
/deep/.el-calendar-table {
  > thead {
    > th:nth-of-type(6) {
      background: #4ecb73;
    }
    > th:nth-of-type(7) {
      background: #4ecb73;
    }
  }
}

/deep/.el-calendar-table__row {
  > td:nth-of-type(6) {
    .el-calendar-day {
      border-top: 3px solid #4ecb73;
      // border-bottom: 3px solid #4ECB73;
    }
  }
  > td:nth-of-type(7) {
    .el-calendar-day {
      border-top: 3px solid #4ecb73;
      // border-bottom: 3px solid #4ECB73;
    }
  }
}
.dataForm {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #ff4d4f;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -65px;
    color: #ff4d4f;
  }
  .disX {
    width: 439px;
    height: 80px;
    display: flex;
    // background: red;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .dataDis {
    display: flex;
    .el-input {
      width: 563px;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      color: #666666;
      margin-left: 10px;
    }
  }
}
.pxDialog {
  .xDItem {
    .el-input {
      width: 135px;
      margin: 0 10px;
    }
  }
  .el-form-item__label {
    position: relative;
  }
  .posiA {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #ff4d4f;
  }
  .posiB {
    position: absolute;
    top: 0px;
    left: -107px;
    color: #ff4d4f;
  }
  .posiC {
    position: absolute;
    top: 0px;
    left: -107px;
    color: #ff4d4f;
  }
  .posiD {
    position: absolute;
    top: 0px;
    left: -122px;
    color: #ff4d4f;
  }
  .posiE {
    position: absolute;
    top: 0px;
    left: -135px;
    color: #ff4d4f;
  }
  .posiF {
    position: absolute;
    top: 0px;
    left: -67px;
    color: #ff4d4f;
  }
  .posiG {
    position: absolute;
    top: 0px;
    left: -94px;
    color: #ff4d4f;
  }
  .posiL {
    position: absolute;
    top: 0px;
    left: -73px;
    color: #ff4d4f;
  }
  .posiV {
    position: absolute;
    top: 0px;
    left: -135px;
    color: #ff4d4f;
  }
  .posiZ {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .el-form {
    width: 1000px;
    margin: auto;
  }

  .disK {
    .el-button {
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      text-align: center;
      color: #246deb;
    }
  }
  .disL {
    display: flex;
    .el-input {
      width: 630px;
    }
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #ff4d4f;
      margin: 0 10px;
    }
  }
  .spanA {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ff4d4f;
    > span:nth-child(1) {
      margin: 0 10px;
    }
  }
  .disK {
    display: flex;
    .el-input {
      width: 178px;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #ff4d4f;
      margin: 0 40px 0 10px;
    }
  }

  .disN {
    display: flex;
    align-items: center;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ff4d4f;
      margin-left: 10px;
    }
  }
  .disX {
    display: flex;
    // background: red;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .xfrq {
    .el-date-editor {
      // width: 600px;
    }
  }
  .disW {
    display: flex;
    .inputW {
      .el-date-editor {
        width: 230px;
      }
    }
    .el-input {
      width: 50px;
    }
  }
  .disE {
    display: flex;
    .el-date-editor {
      // width: 490px;
    }
  }
  .disH {
    display: flex;
    .el-input {
      width: 256px;
      margin-right: 10px;
    }
    > span {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      color: #e74c3c;
    }
  }
  .disG {
    display: flex;
    .el-form-item {
      margin-right: 50px;
    }
    .el-input {
      width: 256px;
      margin-right: 10px;
    }
    > span:nth-child(2) {
      line-height: 40px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
      margin-right: 50px;
    }
  }
  .disFF {
    .el-input {
      width: 740px;
    }
  }
  .disF {
    display: flex;
    .el-input {
      width: 710px;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      text-align: right;
      color: #666666;
      margin: 0 20px 0 10px;
    }
  }
  .proFm {
    display: flex;
    flex-direction: column;
    .spanB {
      margin-left:5rem ;
      display: flex;
      align-items: flex-end;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ff4d4f !important;
      margin-bottom: 20px;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
  }
  .fpCss {
    .el-textarea {
      width: 740px;
    }
  }
  .proA {
    width: 740px;
    // height: 300px;
    background: #ffffff;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
  }
  .disB {
    display: flex;
    .el-input {
      width: 80px;
      margin-right: 10px;
    }
    /deep/.el-form-item__content {
      margin: 0 45px;
    }
  }
  .disA {
    display: flex;
    .el-select {
      width: 280px;
      height: 40px;
      margin-right: 50px;
    }
    .el-input {
      width: 242px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .disAA {
    display: flex;
    .el-select {
      width: 280px;
      height: 40px;
      margin-right: 50px;
    }
    .el-input {
      width: 280px;
      height: 40px;
      margin-right: 10px;
    }
  }
  /deep/ .el-form-item__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    /* identical to box height */
    text-align: right;
    color: #8c8c8c;
  }
  .inputA {
    // background: red;
    .el-input {
      width: 740px;
      height: 40px;
    }
  }
}
.btn {
  margin: 20px 0 30px 0;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
/deep/.is-selected {
  color: #1989fa;
}
/deep/thead {
  th {
    margin-right: 10px;
    text-align: center !important;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    background: #246deb;
    border-radius: 4px 4px 0px 0px;
  }
}
tbody {
  p {
    width: 130px;
    text-align: center;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
  }
}
// /deep/.prev {
//   width: 200px;
// }
// /deep/.el-calendar-table tr td:first-child {
//   border: none;
// }
// /deep/.el-calendar-table td {
//   border: none;
// }
// /deep/.el-calendar-day {
//   box-sizing: border-box;
//   padding: 8px;
//   height: 230px;
//   width: 130px;
//   margin: 10px auto;
//   background: #eaf1fd;
//   border-top: 3px solid #87aff4;
//   border-bottom: 3px solid #87aff4;
// }
.itemFome {
  /deep/.el-input {
    width: 50px;
    height: 20px;
  }
  /deep/.el-input__inner {
    height: 20px;
  }
  /deep/.el-form-item {
    margin-bottom: 0px;
  }
}
 /deep/ .el-upload div,/deep/ .el-upload div img{
  width: 100%;
  height: 100%;
}

.conendTime{
  margin-top: 10px;
}
.conendTime /deep/ .el-input{
  width: auto !important;
}
/deep/.el-input input{
  color: #666 !important;
}
/deep/.el-form-item input,/deep/.el-date-editor{
  background: #fff !important;
  color: #666 !important;
}
/deep/ .el-calendar__header{
  display: none;
}
.her{
    width: 10rem;
    height: 4rem;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1.5rem;
    cursor: pointer;
}
.btnHer{
  display: flex;
  justify-content: end;
}
::v-deep {
    .el-calendar-table:not(.is-range) td.next,.el-calendar-table:not(.is-range) td.prev{
      pointer-events: none;
    }
  }
  ::v-deep .el-calendar-table:not(.is-range) td.next {
  display: none;
}
::v-deep .el-calendar-table:not(.is-range) td.prev {
  visibility: hidden;
}
.ting{
  text-align: center;
  font-size: 1.8rem;
  color: #333;
}
.son_border{
  border: 1px dashed #E8ECF4;
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 0;
  box-sizing: border-box;
  margin-bottom: 2rem;
  ::v-deep .el-input{
    width: 27rem !important;
  }
  img{
    width: 4rem;
    height: 4rem;
    margin-left: 4.5rem;
    cursor: pointer;
  }
}
.form_ages{
  display: flex;
  align-items: center;
  >span{
    margin: 0 2rem;
  }
}
</style>